import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { usePartnerContext } from '../context'
import { query } from '../graphql'

export const usePartnerIntegrations = ({ select }) => {
  const { partner } = usePartnerContext()

  return useQuery({
    queryKey: QUERY_KEYS.partnerIntegrationsByPartner(partner.id),
    queryFn: () =>
      query({
        query: 'listIntegrationsByPartner',
        variables: {
          partner_id: partner.id
        }
      }),
    select
  })
}
